import React, { type ReactNode } from 'react';

import Loader from '@amzn/meridian/loader';

import AbsoluteCentered from '../absoluteCentered/absoluteCentered';

interface LoadingSpinnerWrapperProps {
  showSpinner: boolean;
  children: ReactNode;
  /** When forms are especially long, the spinner will sometimes display out of view. In such cases, set this to afix
   *  the loader to the center of the screen. */
  centerOfScreen?: boolean;
}

/**
 * Display a loading spinner over the child elements and disable any click events while the spinner is display.
 */
const LoadingSpinnerWrapper = (props: LoadingSpinnerWrapperProps) => {
  const { children, centerOfScreen } = props;
  // eslint-disable-next-line no-process-env
  const showSpinner = props.showSpinner && process.env.NODE_ENV.toLowerCase() !== 'test';
  return (
    <span
      style={{
        ...(showSpinner ? { position: 'relative' } : {}),
      }}
    >
      <span
        style={{
          ...(showSpinner
            ? {
                opacity: 0.5,
                pointerEvents: 'none',
              }
            : {}),
        }}
      >
        {children}
      </span>
      {showSpinner && (
        <AbsoluteCentered centerOfScreen={centerOfScreen}>
          <Loader data-testid="loading-spinner" />
        </AbsoluteCentered>
      )}
    </span>
  );
};

export default LoadingSpinnerWrapper;
